import React from 'react'
import TextInner from '~/components/molecules/Text';

export default function Text({key, index, ...props}) {
  return (
    <TextInner content={props.text} />
  )
}
